import React, { useState } from 'react';
import {
    Container, Box, TextField, Button, Typography, Paper, Stack
} from '@mui/material';
import { usePersistentNavigate } from '../utils/navigation';
import { useAuthContext } from '../context/AuthContext';
import { registerAdmin } from '../queries/registeradmin';
import { Admin } from '../schema';

const RegisterAdmin: React.FC = () => {
    const navigate = usePersistentNavigate();
    const { accessToken, setAccessToken, logout } = useAuthContext();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [jobRole, setJobRole] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        const admin: Admin = {
            id: '', // Not needed for creation
            firstName,
            lastName,
            emailAddress: email,
            phoneNumber: phone,
            jobRole,
            createdAt: undefined,
            updatedAt: undefined,
        };

        try {
            await registerAdmin({ admin, password }, accessToken!, setAccessToken, logout);
            navigate('/registration-result?success=true');
        } catch (err) {
            setError((err as Error).message);
            navigate('/registration-result?success=false');
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper sx={{ p: 4, mt: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Register New Admin
                </Typography>
                <Box component="form" onSubmit={handleSubmit}>
                    <TextField label="First Name" value={firstName} onChange={e => setFirstName(e.target.value)} fullWidth margin="normal" required />
                    <TextField label="Last Name" value={lastName} onChange={e => setLastName(e.target.value)} fullWidth margin="normal" required />
                    <TextField label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} fullWidth margin="normal" required />
                    <TextField label="Phone Number" value={phone} onChange={e => setPhone(e.target.value)} fullWidth margin="normal" />
                    <TextField label="Job Role" value={jobRole} onChange={e => setJobRole(e.target.value)} fullWidth margin="normal" />
                    <TextField label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} fullWidth margin="normal" required />
                    {error && <Typography color="error">{error}</Typography>}
                    <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                        <Button type="submit" variant="contained">Register Admin</Button>
                        <Button variant="outlined" onClick={() => navigate('/admin')}>Back to Admin Portal</Button>
                    </Stack>
                </Box>
            </Paper>
        </Container>
    );
};

export default RegisterAdmin;
